import { render, staticRenderFns } from "./TaskTemplates.vue?vue&type=template&id=63d43160"
import script from "./TaskTemplates.vue?vue&type=script&lang=js"
export * from "./TaskTemplates.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplates.vue?vue&type=style&index=0&id=63d43160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports